import { render } from "./CardEdicionIdioma.vue?vue&type=template&id=54cefc1a"
import script from "./CardEdicionIdioma.vue?vue&type=script&lang=js"
export * from "./CardEdicionIdioma.vue?vue&type=script&lang=js"

import "./CardEdicionIdioma.vue?vue&type=style&index=0&id=54cefc1a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__